import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import uiReducer from './features/uiSlice';
import alertReducer from './features/alertSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    alerts: alertReducer,
  },
});

export default store;
